import { render, staticRenderFns } from "./BasicLayout.vue?vue&type=template&id=7cb23a32&scoped=true&"
import script from "./BasicLayout.vue?vue&type=script&lang=ts&"
export * from "./BasicLayout.vue?vue&type=script&lang=ts&"
import style0 from "./BasicLayout.vue?vue&type=style&index=0&id=7cb23a32&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb23a32",
  null
  
)

export default component.exports